import { DatePipe} from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CommonService, SharedserviceService } from 'src/app/services';
declare var $: any;

@Component({
  selector: 'app-offer-view',
  templateUrl: './offer-view.component.html',
  styleUrls: ['./offer-view.component.scss'],
  providers: [DatePipe]
})
export class OfferViewComponent implements OnInit {

 
  travellers: FormGroup;
  searchForm: FormGroup;
  return_d_date: any;
  rreturn_d_date: any;
  readMore: boolean = false;
  imagesrc:any;
  public flag: any = 1;
  flight_type_new:any;
  bodydata: any = {}; 
  ccData:any=[];
  TotalCount: any;
  data:any;
  flightdetails:any;
  total: any;
  offerDetl:any;
  combine_list:any =[];
  travDetl:any;
  offerDtlType:any;
  userdata:any;
  keys: any; public page: number = 1; start = 0; msg: any;
  ticketDis:any;
  aval_seat: any;
  oneWayDate: any;
  ownerData: any;
  constructor(
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public dataservice: CommonService,
    public httpClient: SharedserviceService,
    public router: Router,
    private toastr: ToastrManager,

  ) { 
    this.offerDetl = JSON.parse(sessionStorage.getItem("offerDetail"));
    // this.offerDtlType = JSON.parse(sessionStorage.getItem("offerType"));
    this.travDetl = JSON.parse(sessionStorage.getItem("travlerDetail"));
    this.userdata= JSON.parse(localStorage.getItem("userAgency_diamond"));
    this.oneWayDate= JSON.parse(localStorage.getItem("oneWayDate"));
    this.ownerData= JSON.parse(sessionStorage.getItem("ownerData"));
  }

  ngOnInit() {
    console.log("offerDetail",this.offerDetl);
    console.log("travDetl",this.travDetl);
    this.offerDetail();
    this.offerDetailBlock();

    this.searchForm = this.fb.group({
      adult: 1,
      child: 0,
      infant: 0
    })
    this.travellers = this.fb.group({
      adult: ['1'],
      child: ['0'],
      infant: ['0'],
    });
    
    var fixmeTop = $('.fixme').offset().top;
    $(window).scroll(function() {
      var currentScroll = $(window).scrollTop();
      if (currentScroll >= fixmeTop) {
          $('.fixme').css({
              position: 'fixed',
              top: '0',
              left: '0'
          });
      } else {
          $('.fixme').css({
              position: 'static'
          });
      }
    });


  }




  offerDetail(){
    if(this.offerDetl.one_way_flight_status == 1){
      this.flight_type_new = "0";
    }else if(this.offerDetl.return_flight_status == 1){
      this.flight_type_new = "1";
    }
    this.bodydata = {
      departure_city_id:this.offerDetl.departure_city_id,
      departure_airport_id: this.offerDetl.departure_airport_id,
      arrival_city_id:this.offerDetl.arrival_city_id,
      arrival_airport_id: this.offerDetl.arrival_airport_id,
      adult:this.travDetl.adult,
      children:this.travDetl.child,
      infant: this.travDetl.infant,
      // flight_type: "0"
      flight_type: this.flight_type_new.toString()
    }
    console.log("checkData:::::::::::::::",this.bodydata);
    // this.httpClient.post('v1/search_offer_flight/flight_list_flight_type', this.bodydata).subscribe((res) => {
    this.httpClient.post('v1/search_offer_flight/flight_list_sector_wise', this.bodydata).subscribe((res) => {
      if (res.replyCode == 'success') {
        if (res.data) {
          this.flag = false;
          this.imagesrc=res.imgBasePath;
            (res.data).forEach(element => {
              this.combine_list.push(element)
              this.combine_list.sort((a,b) => a.departure_date.localeCompare(b.departure_date));
              if(element.inventory_user_Type=="self"){
                this.ccData.push(element.departure_date);
                this.ticketDis= res.ticketDisplaySetting.ticket_display_status;
              }
            });
          // this.flightdetails = res.data;
          // this.flightdetails.sort((a,b) => a.departure_date.localeCompare(b.departure_date));
          // this.keys = Object.keys(this.flightdetails[0]);
          // this.TotalCount = res.totalRecords;
        } else {
          this.flag = true;
          this.msg = 'Sorry for the inconvenience caused. Please contact at '+this.ownerData.mobile+' for customer support.'
        }
      } else {
        this.flag = true;
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    }, err => {
      this.flag = true;
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }

  offerDetailBlock(){
    if(this.offerDetl.one_way_flight_status == 1){
      this.flight_type_new = "0";
    }else if(this.offerDetl.return_flight_status == 1){
      this.flight_type_new = "1";
    }
    this.bodydata = {
      departure_city_id:this.offerDetl.departure_city_id,
      departure_airport_id: this.offerDetl.departure_airport_id,
      arrival_city_id:this.offerDetl.arrival_city_id,
      arrival_airport_id: this.offerDetl.arrival_airport_id,
      adult:this.travDetl.adult,
      children:this.travDetl.child,
      infant: this.travDetl.infant,
      // flight_type: "0"
      flight_type: this.flight_type_new.toString()
    }
    console.log("checkData:::::::::::::::",this.bodydata);
    this.httpClient.post('v1/search_offer_flight/block_flight_list_sector_wise', this.bodydata).subscribe((res) => {
      if (res.replyCode == 'success') {        
        if (res.data) {
          this.ccData = res.data;
          this.flag = false;
          this.imagesrc=res.imgBasePath;
              (res.data).forEach(element => {
                this.combine_list.push(element)
                this.combine_list.sort((a,b) => a.departure_date.localeCompare(b.departure_date));
                  this.ccData.push(element.departure_date);
                  this.ticketDis= res.ticketDisplaySetting.ticket_display_status
                  // console.log("date List :::::::::::",this.ccData);
              });
          // this.flightdetails = res.data;
          // this.keys = Object.keys(this.flightdetails[0]);
          // this.TotalCount = res.totalRecords;
        } else {
          this.flag = true;
          this.msg = 'Sorry for the inconvenience caused. Please contact at '+this.ownerData.mobile+' for customer support.'
        }
      } else {
        this.flag = true;
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    }, err => {
      this.flag = true;
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }

  durationdiff(dep_time, arr_time, dep_date, type) {
    var dep_hr = parseInt(dep_time.split(':')[0]);
    var arr_hr = parseInt(arr_time.split(':')[0]);
    if (arr_hr < dep_hr) {
      var nwdate;
      if (!dep_date) {
        nwdate = new Date();
      } else {
        nwdate = new Date(dep_date);
      }
      var newdate = nwdate.setDate(nwdate.getDate() + 1);
      if (type == 'oneway') {
        this.return_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
      } else {
        this.rreturn_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
      }

    } else {
      this.return_d_date = dep_date;
      this.rreturn_d_date = dep_date;
    }
    var start_date = dep_date + " " + dep_time;
    var end_date = this.return_d_date + " " + arr_time;
    return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
  }

  bookflight(flight) {
    const self = this;
    var formvalue = this.searchForm.value
    // console.log("formvalue ::::",formvalue)
    this.aval_seat = flight.total_available_seats
     var totalseat = Number(this.travDetl.adult) + Number(this.travDetl.child) + Number(this.travDetl.infant)
    // console.log("formadata : : ",formvalue,"available seat ",this.aval_seat,"total seat",totalseat,"flight",flight)
    if (this.aval_seat >= totalseat) {
      var senddata = {
        flight_id: flight.flight_id,
        trip_type: flight.return_flight.toString(),
        departure_date: flight.departure_date,
        return_date: flight.return_flight == 1 ? flight.return_flight_data.return_departure_date : '',
        adult: this.travDetl.adult,
        children:  this.travDetl.child,
        infant:  this.travDetl.infant,
        inventory_user_Type: ""
      }
      var totalseat1 = Number(this.travDetl.adult) + Number(this.travDetl.child) + Number(this.travDetl.infant)
      sessionStorage.setItem("search_form",JSON.stringify(senddata))
      localStorage.setItem("traveller_by_inventory", totalseat1.toString())
      // console.log("search form :::::",this.searchForm.value);
      this.dataservice.searchedflightdetail(senddata);
    } else {
      $('#confirmbooking').modal('show');
    }
  }


  getDataDiff(s_date, e_date) {
    var diff = e_date.getTime() - s_date.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
    return hours + " hrs " + ": " + minutes + " min";
  }
  contactSupport() {
    $('#offlineModle').modal('show');
  }

  checkOffer(){
    $('#totalpassengers').modal('show');
  }
  traveller() {
    var adult = this.travellers.value.adult;
    var child = this.travellers.value.child;
    var infant = this.travellers.value.infant;

    if (adult != '' && child != '' && infant != '') {
      if (parseInt(adult) >= parseInt(infant)) {
        this.total = parseInt(adult) + parseInt(child) + parseInt(infant);

        this.searchForm.patchValue({
          adult: parseInt(adult),
          child: parseInt(child),
          infant: parseInt(infant)
        });

        $('#totalpassengers').modal('hide');
        this.searchForm.patchValue({ travellers: this.total });
        console.log("Total travlers:::::", this.searchForm.value);
        sessionStorage.setItem("travlerDetail", JSON.stringify(this.searchForm.value));
        
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/offer-view']);

      } else {
        alert('Please select infant less than adult');
      }

    } else {
      alert('All Field is required');
    }
  }



  
  

}
